module.exports = __webpack_public_path__ + "static/img/black_body.d2c29f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black_body.png
// module id = FSUB
// module chunks = 94